var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.45455 0 0 4.45455 0 10C0 15.5455 4.45455 20 10 20C15.5455 20 20 15.5455 20 10C20 4.45455 15.5455 0 10 0Z",
    fill: "#EA5455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3633 7.90874L11.2724 9.99965L13.3633 12.0906C13.7269 12.4542 13.7269 12.9996 13.3633 13.3633C13.1815 13.5451 12.9996 13.636 12.7269 13.636C12.4542 13.636 12.2724 13.5451 12.0906 13.3633L9.99965 11.2724L7.90874 13.3633C7.72692 13.5451 7.5451 13.636 7.27237 13.636C6.99964 13.636 6.81783 13.5451 6.63601 13.3633C6.27237 12.9996 6.27237 12.4542 6.63601 12.0906L8.72692 9.99965L6.63601 7.90874C6.27237 7.5451 6.27237 6.99964 6.63601 6.63601C6.99964 6.27237 7.5451 6.27237 7.90874 6.63601L9.99965 8.72692L12.0906 6.63601C12.4542 6.27237 12.9996 6.27237 13.3633 6.63601C13.7269 6.99964 13.7269 7.5451 13.3633 7.90874Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosered);
export default __webpack_public_path__ + "static/media/closered.7112aca647ea5b2e8dbc10b1fd03e836.svg";
export { ForwardRef as ReactComponent };